import React, { useState, useEffect } from "react";

const datePickerStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    padding: "10px",
    borderRadius: "6px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
  },
  inputWrapper: {
    position: "relative",
  },
  input: {
    width: "100%",
    padding: "10px",
    backgroundColor: "transparent",
    color: "#ccc",
    border: "1px solid #314158",
    borderRadius: "8px",
    fontSize: "16px",
    outline: "none",
    appearance: "none",
  },
  icon: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    fontSize: "18px",
    color: "#888",
  },
};

const DatePicker = ({ label, mandatory, onChange, value }) => {
  const [date, setDate] = useState("");

  const formatDateForInput = (dateValue) => {
    if (!dateValue) return "";
    
    try {
      // Se já tiver no formato YYYY-MM-DD, retornar:
      if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
        return dateValue;
      }
      
      // Se estiver em ISO date string ou Date object, converte para YYYY-MM-DD
      const dateObj = new Date(dateValue);
      if (isNaN(dateObj.getTime())) return "";
      
      return dateObj.toISOString().split('T')[0];
    } catch (error) {
      console.error('Error formatting date:', error);
      return "";
    }
  };

  useEffect(() => {
    const formattedDate = formatDateForInput(value);
    setDate(formattedDate);
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setDate(newValue);
    if (onChange) {
      const isoValue = newValue ? new Date(newValue + 'T00:00:00').toISOString() : '';
      onChange(isoValue);
    }
  };

  return (
    <div style={datePickerStyles.container}>
      {label && (<label style={datePickerStyles.label}>{mandatory ? label + " * " : label}</label>)}
      <div style={datePickerStyles.inputWrapper}>
        <input
          type="date"
          style={datePickerStyles.input}
          value={date}
          onChange={handleChange}
        />
        <span style={datePickerStyles.icon}></span>
      </div>
    </div>
  );
};

export default DatePicker;